import { PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import ProgressTest, { mapStateToProps } from './component';

import { routes as progressTestDayView } from './ProgressTestDayView';
import { routes as progressTestCourseView } from './ProgressTestCourseView';
import { routes as progressTestRubricView } from './ProgressTestRubricView';
import ViewNav from 'components/ViewNav';
import ProgressTestSessionNav from 'components/ProgressTestSessionNav';
import { accessors as ProgressTests } from 'data/ProgressTests';

export default ({ getState }) => ({
  appBars: {
    sticky: {
      ptNav: {
        component: ProgressTestSessionNav,
        props: {
          isUnitQuiz: true,
        },
        order: 1,
      },
      'view-nav': {
        component: ViewNav,
        props: {
          showExpandable: true,
        },
        order: 3,
      },
    },
  },
  path: 'progress-test',
  component: ProgressTest,
  canAccess: ({ params }) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressTest.View) &&
    TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.ProgressTest),
  tab: {
    label: (params) => ProgressTests.getProgressTestTab(getState(), params.groupId),
    order: 6,
    isVisible: (params) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressTest.View) &&
      TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.ProgressTest),
  },
  breadcrumbLabels: (props) => {
    const { params: { groupId, progressTestIndex }, buildRoute } = props;
    const currentProps = mapStateToProps(getState(), props);
    if (! currentProps || ! currentProps.currentProgressTestPlan) return;
    const labelName = ProgressTests.getPTNameWithGroup(
      getState(),
      currentProps.currentProgressTestPlan.name,
      groupId);
    return {
      label: labelName,
      href: buildRoute(`/group/${groupId}/progress-test/${progressTestIndex}/course`),
    };
  },
  childRoutes: [
    progressTestDayView,
    progressTestCourseView,
    progressTestRubricView,
  ],
});



// WEBPACK FOOTER //
// ./containers/Group/ProgressTest/routes.js